import React from "react";
import SubLink from '../../Route/SubLink';
import { RefillersManager } from "../../Route/SubLinkJSON";

const RefillerManager = () => {
 
  return (
    <React.Fragment>
      <SubLink sublinks={RefillersManager}/>
    </React.Fragment>
  );

}

export default RefillerManager;
